<script lang="ts">
    import Navbar from '../components/Navbar.svelte';
    import { getTokenStorage } from '../utils/localStorage';

    let isAuthenticated = $state(false);

    $effect(() => {
        const token = getTokenStorage();
        isAuthenticated = !!token;
        if (!isAuthenticated) {
             window.location.hash = '/login';
        }
    });

    let importUrl = $state('');
    let repositoryName = $state('');
    let description = $state('');
    let visibility = $state('public');

    async function handleImport(event: Event) {
        event.preventDefault();
        // Mock import logic
        alert(`Attempting to import from ${importUrl} as ${repositoryName} (visibility: ${visibility}).\nDescription: ${description}`);
        console.log({ importUrl, repositoryName, description, visibility });
        // Simulate a delay
        // await new Promise(resolve => setTimeout(resolve, 2000));
        // alert('Import simulated successfully!');
        // window.location.hash = '/repositories'; // Redirect to repositories list
    }
</script>

<Navbar />

<div class="min-h-screen bg-gray-50 dark:bg-gray-950">
    <!-- Header -->
    <div class="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">Import a Repository</h1>
            <p class="mt-2 text-sm text-gray-600 dark:text-gray-400">
                Bring your existing projects into Koru.
            </p>
        </div>
    </div>

    <!-- Main Content -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div class="bg-white dark:bg-gray-800 shadow sm:rounded-lg p-6">
            <form onsubmit={handleImport} class="space-y-6">
                <div>
                    <label for="import-url" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Clone URL (HTTPS or SSH) *
                    </label>
                    <input
                        type="text"
                        id="import-url"
                        bind:value={importUrl}
                        required
                        class="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-200"
                        placeholder="e.g., https://github.com/user/repo.git or git@github.com:user/repo.git"
                    />
                    <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
                        Paste the URL of the repository you want to import.
                    </p>
                </div>

                <div>
                    <label for="repository-name" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Repository Name *
                    </label>
                    <input
                        type="text"
                        id="repository-name"
                        bind:value={repositoryName}
                        required
                        class="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-200"
                        placeholder="e.g., my-imported-project"
                    />
                    <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
                        This will be the name of your new repository on Koru.
                    </p>
                </div>

                <div>
                    <label for="description" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Description (optional)
                    </label>
                    <textarea
                        id="description"
                        bind:value={description}
                        rows="3"
                        class="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-700 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-200"
                        placeholder="A short description of your imported repository."
                    ></textarea>
                </div>

                <div>
                    <label for="visibility" class="block text-sm font-medium text-gray-700 dark:text-gray-300">
                        Visibility *
                    </label>
                    <select
                        id="visibility"
                        bind:value={visibility}
                        class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-200"
                    >
                        <option value="public">Public</option>
                        <option value="private">Private</option>
                    </select>
                    <p class="mt-2 text-xs text-gray-500 dark:text-gray-400">
                        Public repositories are visible to everyone; private ones are only accessible to you and collaborators.
                    </p>
                </div>

                <div class="pt-4 border-t border-gray-200 dark:border-gray-700">
                    <button
                        type="submit"
                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-indigo-700 dark:hover:bg-indigo-800"
                    >
                        Begin Import
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
